import PropTypes from 'prop-types';
import { FULFILLMENT_METHODS } from '../../utils/constants';

export const fulfillmentMethodType = PropTypes.oneOf(FULFILLMENT_METHODS);

export const fulfillmentMethodsType = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    targetMethod: fulfillmentMethodType.isRequired,
  }),
);
